import type { SVGProps } from "react";

const Primary = (props: SVGProps<SVGSVGElement>) => (
  <svg width="220" height="178" viewBox="0 0 220 178" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="110" cy="88" r="80" fill="url(#paint0_linear_1052_23319)" />
    <circle cx="26" cy="28" r="8" fill="white" />
    <circle cx="198" cy="134" r="6" fill="white" />
    <circle cx="25" cy="146" r="10" fill="white" />
    <circle cx="210" cy="54" r="10" fill="white" />
    <circle cx="191" cy="19" r="7" fill="white" />
    <g filter="url(#filter0_dd_1052_23319)">
      <path
        d="M110 54.9529L116.912 52.0578L110.001 55.002V137.432L173.69 110.743V28.2767L174 28.1466L173.69 28.009V27.8705L173.53 27.9384L110.503 0L46 27.4765L46.3053 27.6076L46 109.74L110 137.383L110 54.9529Z"
        fill="#F0F1F3"
      />
      <path d="M110 54.9531V137.383L46 109.74L46.3053 27.6076L110 54.9531Z" fill="url(#paint1_linear_1052_23319)" />
      <path d="M110.001 55.002V137.432L173.69 110.744V27.8705L110.001 55.002Z" fill="url(#paint2_linear_1052_23319)" />
      <path d="M110 54.9529L174 28.1466L110.503 0L46 27.4765L110 54.9529Z" fill="white" />
      <path
        d="M70.1256 17.1997L133.882 44.9503L134.461 65.173L152.299 57.8125L151.759 37.4622L86.1173 10.3876L70.1256 17.1997Z"
        fill="#F3EEFF"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1052_23319"
        x="26"
        y="0"
        width="168"
        height="177.432"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23319" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23319" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23319" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23319" result="effect2_dropShadow_1052_23319" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23319" result="shape" />
      </filter>
      <filter
        id="filter1_b_1052_23319"
        x="74"
        y="96"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1052_23319" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1052_23319" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_1052_23319" x1="110" y1="8" x2="110" y2="168" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EAE6FF" />
        <stop offset="1" stopColor="#D6D3E7" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_23319"
        x1="46"
        y1="110.154"
        x2="71.2754"
        y2="41.7014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="1" stopColor="#F1E6FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1052_23319"
        x1="110"
        y1="56.6154"
        x2="182.166"
        y2="70.983"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="1" stopColor="#F4EBFF" />
      </linearGradient>
    </defs>
  </svg>
);

const Gray = (props: SVGProps<SVGSVGElement>) => (
  <svg width="220" height="178" viewBox="0 0 220 178" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="110" cy="88" r="80" fill="url(#paint0_linear_1052_23333)" />
    <circle cx="26" cy="28" r="8" fill="white" />
    <circle cx="198" cy="134" r="6" fill="white" />
    <circle cx="25" cy="146" r="10" fill="white" />
    <circle cx="210" cy="54" r="10" fill="white" />
    <circle cx="191" cy="19" r="7" fill="white" />
    <g filter="url(#filter0_dd_1052_23333)">
      <path
        d="M110 54.9529L116.912 52.0578L110.001 55.002V137.432L173.69 110.743V28.2767L174 28.1466L173.69 28.009V27.8705L173.53 27.9384L110.503 0L46 27.4765L46.3053 27.6076L46 109.74L110 137.383L110 54.9529Z"
        fill="#F0F1F3"
      />
      <path d="M110 54.9531V137.383L46 109.74L46.3053 27.6076L110 54.9531Z" fill="url(#paint1_linear_1052_23333)" />
      <path d="M110.001 55.002V137.432L173.69 110.743V27.8705L110.001 55.002Z" fill="url(#paint2_linear_1052_23333)" />
      <path d="M110 54.9529L174 28.1466L110.503 0L46 27.4765L110 54.9529Z" fill="white" />
      <path
        d="M70.1256 17.1997L133.882 44.9503L134.461 65.173L152.299 57.8126L151.759 37.4622L86.1173 10.3876L70.1256 17.1997Z"
        fill="#F5F3F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1052_23333"
        x="26"
        y="0"
        width="168"
        height="177.432"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23333" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23333" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23333" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23333" result="effect2_dropShadow_1052_23333" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23333" result="shape" />
      </filter>
      <filter
        id="filter1_b_1052_23333"
        x="74"
        y="96"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1052_23333" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1052_23333" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_1052_23333" x1="110" y1="8" x2="110" y2="168" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F3EDFA" />
        <stop offset="1" stopColor="#EBEAED" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_23333"
        x1="46"
        y1="110.154"
        x2="71.2754"
        y2="41.7014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DEE1E8" />
        <stop offset="1" stopColor="#EFF1F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1052_23333"
        x1="110"
        y1="56.6154"
        x2="182.166"
        y2="70.983"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E4E7EC" />
        <stop offset="1" stopColor="#F2F4F7" />
      </linearGradient>
    </defs>
  </svg>
);

export const IllustrationBox = {
  Primary,
  Gray,
};
